// extracted by mini-css-extract-plugin
export default {"icon":"VFwRug0TuS00avNkt7WX","disabled":"Us6Blv5rNL4NExLnJXQg","placeHolderShimmer":"YKz4BeXRNImidj07dLHL"};